<!-- Modal Backdrop -->
<div class="blur-modal-backdrop" 
     [class.fade-in]="!isClosing" 
     [class.fade-out]="isClosing"
     (click)="onBackdropClick($event)">
</div>

<!-- Modal -->
<div class="mantis-modal" 
     role="dialog" 
     aria-modal="true" 
     [class.modal-in]="!isClosing" 
     [class.modal-out]="isClosing">
    <div class="mantis-modal-dialog system-chat-room-modal-dialog" (click)="$event.stopPropagation()">
        <!-- Modal Header -->
        <div class="mantis-modal-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0 fw-bold">Edit group chat</h5>
            <button type="button" 
                    class="btn-close" 
                    (click)="onClose()"
                    aria-label="Close">
                <img src="assets/common/ic_x_s_size.svg" alt="" />
            </button>
        </div>
        
        <!-- Modal Body -->
        <div class="mantis-modal-body">
            <form #systemChatRoomForm="ngForm">
                <!-- Reference name -->
                <div class="form-group mb-3">
                    <label class="form-label">
                        Reference name <span class="text-danger">*</span>
                    </label>
                    <input type="text"
                           class="form-control"
                           name="reference_name"
                           required
                           [(ngModel)]="formData.reference_name"
                           placeholder="Enter reference name"
                           [class.is-invalid]="systemChatRoomForm.submitted && !formData.reference_name?.trim()">
                    <small class="form-text text-muted">
                        Visible only in the CMS. Use this as an internal label.
                    </small>
                    <div class="invalid-feedback d-block" *ngIf="systemChatRoomForm.submitted && !formData.reference_name?.trim()">
                        Reference name is required.
                    </div>
                </div>

                <!-- Group chat name -->
                <div class="form-group mb-3">
                    <label class="form-label">
                        Group chat name <span class="text-danger">*</span>
                    </label>
                    <input type="text"
                           class="form-control"
                           name="name"
                           required
                           [(ngModel)]="formData.name"
                           placeholder="Enter group chat name"
                           [class.is-invalid]="systemChatRoomForm.submitted && !formData.name?.trim()">
                    <small class="form-text text-muted">
                        This name is shown to users in the app and is how they'll see the group chat.
                    </small>
                    <div class="invalid-feedback d-block" *ngIf="systemChatRoomForm.submitted && !formData.name?.trim()">
                        Group chat name is required.
                    </div>
                </div>

                <!-- Description and Image Row -->
                <div class="row mb-3">
                    <!-- Description -->
                    <div class="col-md-8">
                        <div class="form-group">
                            <label class="form-label">
                                Description (optional)
                            </label>
                            <textarea class="form-control description-textarea"
                                      name="description"
                                      [(ngModel)]="formData.description"
                                      placeholder="Enter description"></textarea>
                            <small class="form-text text-muted">
                                This description is visible only to you.
                            </small>
                        </div>
                    </div>

                    <!-- Image -->
                    <div class="col-md-4">
                        <div class="form-group">
                            <label class="form-label">
                                Image (optional)
                            </label>
                            <div class="image-upload-container">
                                <div *ngIf="formData.imageUrl" class="image-preview">
                                    <img [src]="formData.imageUrl" alt="Chat room image" class="preview-image">
                                    <button type="button" 
                                            class="btn-remove-image" 
                                            (click)="onRemoveImage()"
                                            title="Remove image">
                                        <i class="ti ti-x"></i>
                                    </button>
                                </div>
                                <div *ngIf="!formData.imageUrl"
                                     class="image-upload-placeholder"
                                     (click)="onImagePlaceholderClick(fileInput)">
                                    <label for="system-chat-room-image-input" 
                                           class="image-upload-label"
                                           (click)="onLabelClick($event)">
                                           <img src="assets/common/ic_upload_m_size.svg" alt="" class="image-upload-icon">
                                           <span>Upload</span>
                                    </label>
                                    <input type="file"
                                           id="system-chat-room-image-input"
                                           accept="image/*"
                                           class="d-none"
                                           #fileInput
                                           (change)="onImageSelect($event)">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Users can send messages checkbox -->
                <!--
                <div class="form-group mb-3 checkbox-with-description">
                    <div class="form-check checkbox-column">
                        <input class="form-check-input"
                               type="checkbox"
                               name="usersCanSendMessages"
                               id="users-can-send-messages"
                               [checked]="!formData.is_read_only"
                               (change)="onUsersCanSendMessagesChange($event)">
                    </div>
                    <div class="checkbox-text-column">
                        <label class="form-check-label" for="users-can-send-messages">
                            Users can send messages
                        </label>
                        <small class="form-text text-muted mt-0">
                            Choose whether all members can send messages or if posting is limited to coaches only.
                        </small>
                    </div>
                </div>
                -->

                <!-- Show chat in the app checkbox -->
                <div class="form-group mb-0 checkbox-with-description">
                    <div class="form-check checkbox-column">
                        <input class="form-check-input"
                               type="checkbox"
                               name="showInApp"
                               id="show-in-app"
                               [checked]="formData.show_in_the_app"
                               (change)="onShowInAppChange($event)">
                    </div>
                    <div class="checkbox-text-column">
                        <label class="form-check-label" for="show-in-app">
                            Show chat in the app
                        </label>
                        <small class="form-text text-muted mt-0">
                            Choose whether users can see this group chat in the app.
                        </small>
                    </div>
                </div>
            </form>
        </div>

        <!-- Modal Footer -->
        <div class="mantis-modal-footer d-flex justify-content-end gap-2">
            <button type="button"
                    class="btn btn-outline-secondary"
                    (click)="onClose()"
                    [disabled]="isSaving">
                Cancel
            </button>
            <button type="button"
                    class="btn btn-primary"
                    (click)="onSave()"
                    [disabled]="isSaving || !isFormValid()">
                <span *ngIf="!isSaving">Save changes</span>
                <span *ngIf="isSaving">Saving...</span>
            </button>
        </div>
    </div>
</div>
